// extracted by mini-css-extract-plugin
export default {"textarea":"n39ahUtAQO9JWUA_xDGs"};